// frontend/src/services/feedbackService.js
import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1';

const getAuthHeaders = (token) => ({
    headers: { Authorization: `Bearer ${token}` }
});

export const submitFeedback = async (token, message) => {
    const response = await axios.post(`${API_BASE_URL}/feedback/`, { message }, getAuthHeaders(token));
    return response.data;
};

// Admin functions
export const getAdminFeedback = async (token, statusFilter = '') => {
    const params = statusFilter ? { status: statusFilter } : {};
    const response = await axios.get(`${API_BASE_URL}/feedback/admin/`, { ...getAuthHeaders(token), params });
    return response.data;
};

export const updateAdminFeedback = async (token, feedbackId, updateData) => {
    const response = await axios.patch(`${API_BASE_URL}/feedback/admin/${feedbackId}`, updateData, getAuthHeaders(token));
    return response.data;
};